<template>
    <div :id="id" class="modal-mask">
        <v-style>//body {overflow: hidden}</v-style>
        <div class="modal-wrapper">
            <div class="modal-container" :class="{ flexContainer: flex }">
                <div class="modalBody" :class="{ withContent, theme, fixHeight }" :style="{ maxWidth: maxWidthValue, minWidth: minWidthValue }">
                    <img src="../../assets/croix.png" width="40" height="40" alt @click="close" class="cross fright abs pointer" /> <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from "@/main";

const MAXWIDTH = {
    default: "default"
};

export default {
    name: "ModalBase",
    props: {
        id: {},
        withContent: {
            default: false
        },
        maxWidth: {
            default: undefined,
            required: false,
            type: String
        },
        minWidth: {
            default: undefined,
            required: false,
            type: String
        },
        fixHeight: {
            default: false,
            required: false,
            type: Boolean
        },
        theme: {
            default: false,
            required: false,
            type: Boolean
        },
        flex: {
            default: true,
            type: Boolean
        }
    },
    computed: {
        maxWidthValue() {
            return this.withContent && this.maxWidth === MAXWIDTH.default ? "60%" : this.maxWidth;
        },
        minWidthValue() {
            return this.withContent && this.minWidth === MAXWIDTH.default ? "60%" : this.minWidth;
        }
    },
    methods: {
        close(e) {
            bus.$emit("closeModal");
            this.$emit("close", e);
            bus.$emit("resetOption", "null");
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

.modal-mask {
    position: fixed;
    z-index: 250;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: block;
    transition: opacity 0.3s ease;
    .cross {
        top: 50px;
        right: 50px;
        z-index: 2;
    }

    > .modal-wrapper {
        display: block;
        height: 100%;

        > .modal-container {
            width: 100%;
            height: 100%;
            margin: 0px auto;
            padding: 20px 30px;
            border-radius: 2px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
            transition: all 0.3s ease;
            font-family: Helvetica, Arial, sans-serif;
            position: relative;

            .logoContainer {
                width: 100%;
            }
            .modalBody {
                color: #777;
                margin: auto;
                min-width: 200px;
                max-height: 80vh;
                overflow-y: auto;
                &.withContent {
                    position: relative;
                    background-color: #fff;
                    border-radius: 10px;
                    padding: 30px 20px 20px 20px;
                    font-family: Roboto, sans-serif;
                    font-size: 13px;
                    &.fixHeight {
                        height: 80vh;
                    }
                    &.theme {
                        @extend %second-background;
                        @extend %primary-text;
                    }

                    > h1,
                    h2,
                    h3,
                    h4,
                    h5,
                    h6 {
                        margin: 0;
                    }

                    > .cross {
                        top: 10px;
                        right: 10px;
                        z-index: 2;
                    }

                    > table {
                        margin: 20px 0;

                        &:last-of-type {
                            margin-bottom: 10px;
                        }

                        th {
                            text-align: left;
                        }
                    }

                    > footer,
                    > section > footer {
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;

                        > button + button {
                            margin-left: 10px;
                        }
                    }
                }

                h1 {
                    font-family: Oswald, Sans-Serif;
                    font-weight: 100;
                    font-size: 23px;
                    text-transform: uppercase;
                }

                h4 {
                    font-size: 16px;
                }

                .title-modal {
                    color: white;
                }

                .brandWrap {
                    padding: 5px;
                }

                p {
                    font-family: Roboto;
                    font-size: 18px;
                }
            }
        }
    }
}
</style>
<style lang="scss">
@import "../../assets/css/themes.scss";
.brandLogo {
    border-radius: 0.7rem;
    background-color: #fff;
    width: 100%;
    -webkit-transition: all 0.1s ease;
    -moz-transition: all 0.1s ease;
    transition: all 0.1s ease;
    color: $color2;
    img {
        margin: auto;
    }
    &:hover,
    &.active {
        background-color: $color4;
        color: #fff;
    }
}
.brandLogo.dark {
    background-color: map_get($dark, second-background);
}
.brandLogo.light {
    background-color: map_get($light, second-background);
}
</style>



// WEBPACK FOOTER //
// ModalBase.vue?ce4f113c